import {AdminWebRoute} from './AdminWebRoute';

export enum RootRoute {
  LogIn = '/',
  GetStarted = '/get-started',
  SignUpVerifyEmail = '/sign-up/verify-email',
  //Admin scenes
  AuthAdminHome = '/admin/',
  //Employee scenes
  EmployeeHome = '/employee/home',
  EmployeePastEvents = '/employee/past-events',
  ColleaguesOverview = '/employee/colleagues-overview',
  CreateHubbl = '/employee/create-hubbl',
  CreateHubblConnect = '/employee/create-hubbl/connect',
  CreateHubblGroup = '/employee/create-hubbl/group',
  CreateHubblVisibilityFilters = 'visibility-filters',
  CreateHubblUserInvitations = 'user-invitations',
  HubblDetails = '/employee/hubbles/:hubblId',
  ConnectDetails = '/employee/connect/:connectId',
  GroupDetails = '/employee/group/:groupId',
  UserProfile = '/employee/user/:userId',
  EmployeeEvent = '/employee/event/:eventId',
  EmployeeSettings = '/employee/settings',
  EmployeeSettingsGeneral = '/employee/settings/general',
  EmployeeSettingsProfile = '/employee/settings/profile',

  //Super admin?
  Invited = '/invited',
  AuthAdminLandingPage = '/auth-admin',
  Event = '/events',
  OnboardingBasicInfo = '/onboarding/basic-info',
  OnboardingInterests = '/onboarding/interests',
  OnboardingAddPhoto = '/onboarding/add-photo',
}

export type WebRoute = RootRoute | AdminWebRoute;
